import { useForm } from "react-hook-form";
import Input from "@/components/ui/input";
import { useEffect, useRef, useState } from "react";
import TextArea from "@/components/ui/text-area";
import DropDown from "@/components/ui/custom-dropdown";
import FileUpload from "@/components/ui/fileUpload";
import { RadioBox } from "@/components/ui/radiobox";
import Calendar from "@/components/ui/icons/calendar";
import axios from "axios";
const dropDownData = [
  "Company Website",
  "Job Portal (LinkedIn, Naukri, Indeed, etc.)",
  "Google/Search Engine",
  "Social Media (Instagram, Facebook etc.)",
  "Employee Referral",
  "Recruiter Contacted Me",
  "College/University Placement Cell",
];
import React from "react";

export default function Application({ jobOpening }) {
  const dateRef = useRef(null);
  const [processing, setProcessing] = useState(false);
  const [status, setStatus] = useState();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
    clearErrors,
    watch,
  } = useForm();
  const dobValue = watch("dob", "");
  const lookingForValue = watch("lookingFor", "");

  const onSubmit = async (data) => {
    setProcessing(true);
    const formData = new FormData();
    // Append text fields to formData
    formData.append("dob", data.dob);
    formData.append("email", data.email);
    formData.append("lookingFor", data.lookingFor);
    formData.append("message", data.message);
    formData.append("name", data.name);
    formData.append("terms", data.terms);
    formData.append("job_opening", jobOpening?.id);

    // Append files to formData
    formData.append("portfolio", data.portfolio[0]); // Access the file from the FileList
    formData.append("resume", data.resume[0]);

    try {
      const response = await axios.post(
        `${process.env.NEXT_PUBLIC_STRAPI_URL}/api/job-application/upload`,
        formData
      );

      setStatus("success");
    } catch (error) {
      setStatus("error");
    }
    setProcessing(false);
  };

  useEffect(() => {
    if (status === "success") {
      clearFields();
      setProcessing(false);
    } else {
      setProcessing(false);
    }
  }, [status]);

  const clearFields = () => {
    reset();
  };
  return (
    <div className="flex flex-col w-full bg-inherit gap-5">
      <form
        className="flex md:flex-row flex-col w-full lg:mt-0 mt-8"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
      >
        <div className="w-full flex flex-col h-full justify-start shrink-0">
          {status === "error" && (
            <div
              className="rounded md:p-12 px-4 py-8 md:text-base font-medium text-center text-red-500 text-red text-sm w-full mt-8 border-dashed border-[1px] border-red-500"
              dangerouslySetInnerHTML={{
                __html: "Error submitting the application.",
              }}
            />
          )}
          {status === "success" && (
            <div
              className="text-center text-darkBlue text-sm w-full border-dashed border-[1px] border-darkGrey mt-8 rounded md:p-12 px-4 py-8 md:text-base font-medium"
              dangerouslySetInnerHTML={{
                __html: "Thank you for applying. Our team will be in touch!",
              }}
            />
          )}
          {status !== "success" && status !== "error" && (
            <>
              <h2 className="md:text-lg text-base text-darkGrey/70 md:my-5 mt-0 mb-5">
                Basic info
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 auto-rows-auto gap-4 w-full mb-4">
                <Input
                  placeholder="Full Name*"
                  type="text"
                  variant="solid"
                  {...register("name", {
                    required: "Please provide your full name.",
                  })}
                  errorKey={errors.name?.message}
                />
                <div>
                  <div className="relative">
                    <Input
                      id="dob"
                      ref={dateRef}
                      placeholder="Date of Birth"
                      type="date"
                      variant="solid"
                      className="mb-4"
                      {...register("dob", {
                        required: `${"Please provide your dob address"}`,
                      })}
                    />
                    {/* {!dobValue && ( */}
                    <span
                      className={`absolute md:top-4 md:w-auto ${
                        !dobValue ? "z-0" : "-z-[1]"
                      } w-[40%] top-5 left-2 text-darkGrey/50 bg-body px-2 md:text-sm text-xs`}
                    >
                      {!dobValue ? "Date of Birth" : dobValue}
                    </span>
                    {/* )} */}

                    <Calendar className="absolute top-0 right-4 w-8 -z-[1]" />
                  </div>
                  {errors.dob?.message && (
                    <p className="my-2 text-xs text-red-500">
                      {errors.dob?.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 auto-rows-auto gap-4 w-full mb-2">
                <Input
                  placeholder="Email*"
                  type="string"
                  variant="solid"
                  {...register("email", {
                    required: `${"Please provide your Email"}`,
                    pattern: {
                      value:
                        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                      message: "Please provide a valid email address",
                    },
                  })}
                  errorKey={errors.email?.message}
                />
                <div>
                  <div className="flex flex-row items-center justify-center border-[0.5px] border-solid border-darkGrey/50 w-full rounded-full relative">
                    <Input
                      placeholder="Where did you hear about this job*"
                      type="string"
                      variant="solid"
                      {...register("lookingFor", {
                        required: `${"Please select/enter a Value "}`,
                      })}
                      border="border-0"
                    />
                    <DropDown
                      dropDownData={dropDownData}
                      onClick={(value) => {
                        setValue("lookingFor", value);
                      }}
                      variant="wide"
                    />
                  </div>
                  {errors?.lookingFor?.message && !lookingForValue && (
                    <p className="my-2 text-xs text-red-500">
                      {errors.lookingFor?.message}
                    </p>
                  )}
                </div>
              </div>

              <div className="w-full flex md:flex-row flex-col lg:gap-6 md:gap-8 gap-6 my-3">
                <TextArea
                  placeholder="Message*"
                  variant="solid"
                  {...register("message", {
                    required: "Please provide your message.",
                  })}
                  errorKey={errors.message?.message}
                />
              </div>

              <div>
                <h2 className="md:text-lg text-base text-darkGrey/70 my-5">
                  Credentials
                </h2>
                <div className="w-full flex md:flex-row flex-col lg:gap-6 md:gap-8 gap-4">
                  <FileUpload
                    placeholderKey="Upload Resume"
                    type="file"
                    name="resume"
                    errorKey={errors.resume?.message}
                    ref={register("resume", {
                      required: "Please upload your Resume",
                    })}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                  <FileUpload
                    placeholderKey="Upload Portfolio"
                    type="file"
                    name="portfolio"
                    errorKey={errors.portfolio?.message}
                    ref={register("portfolio")}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </div>
              </div>
              <div className="flex md:flex-row flex-col gap-8 md:gap-6 items-start justify-between mt-8">
                <div className="flex flex-col w-full">
                  <RadioBox
                    id="terms"
                    name="terms"
                    {...register("terms", {
                      required: "Please accept.",
                    })}
                    subLabel="By clicking the submit button below, I certify that all of the information provided by me on this application is true and complete, and I understand that if any false information, ommissions, or misrepresentations are discovered, my application may be rejected and, if I am employed, my employement may be terminated at any time."
                  />
                  {errors?.terms?.message && (
                    <p className="my-2 text-xs text-red-500">
                      {errors.terms?.message}
                    </p>
                  )}
                </div>

                <button
                  className="bg-darkGrey hover:bg-beige hover:text-darkGrey transition-all duration-300 ease w-full py-3 text-[#f6f5f1] md:w-[150px] rounded-full"
                  type="submit"
                >
                  {processing ? "Submitting..." : `Submit`}
                </button>
              </div>
            </>
          )}
        </div>
      </form>
    </div>
  );
}
